<template>
<div class="hnw-zone">
    
    <div class="tab-container hnw-area-center" v-show="!showGoodsDetail">
        <div class="tab-header" v-if="showType !== 'data'">
            
            <div 
                class="tab-item" 
                :class="{ active: activeTab === 'brandStatistics' }" 
                @click="switchTab('brandStatistics')"
            >
                品牌统计(默认近365天)
            </div>
            <!-- <div 
                class="tab-item" 
                :class="{ active: activeTab === 'productStatistics' }" 
                @click="switchTab('productStatistics')"
            >
                单品统计
            </div>
            <div 
                class="tab-item" 
                :class="{ active: activeTab === 'annualItem' }" 
                @click="switchTab('annualItem')"
            >
                年度单项
            </div> -->
           
            <!-- 右侧操作区域 -->
            <div class="tab-actions">
                <el-date-picker
                    v-model="startDate"
                    type="date"
                    placeholder="开始日期"
                    value-format="timestamp"
                    @change="handleDateChange"
                    class="date-picker"
                    size="mini"
                ></el-date-picker>
                <span class="date-separator">至</span>
                <el-date-picker
                    v-model="endDate"
                    type="date"
                    placeholder="结束日期"
                    value-format="timestamp"
                    @change="handleDateChange"
                    class="date-picker"
                    size="mini"
                ></el-date-picker>
                <el-button type="primary"  v-if="$store.state.store_id=='1780'"  size="mini" @click="handleUpload" class="upload-btn">
                    表格上传
                </el-button>
            </div>
           
        </div>
        <div v-else class="tab-header" >
            
            <div 
                class="tab-item" 
                :class="{ active: activeTab === 'inveStatis' }" 
                @click="switchTab('inveStatis', 'data')"
                v-if="$store.state.storePath.includes('inveStatis')"
            >
                库存分析
            </div>
            <div 
                class="tab-item" 
                :class="{ active: activeTab === 'newSaleAnalysis' }" 
                @click="switchTab('newSaleAnalysis', 'data')"
                v-if="$store.state.storePath.includes('newSaleAnalysis')"
            >
                销售分析
            </div>
        </div>
        <!-- 隐藏的文件输入框 -->
        <input
            type="file"
            ref="excelFile"
            @change="handleFileUpload"
            accept=".xlsx, .xls"
            style="display: none;"
        />
        <div v-if="showType != 'data'" >
            <!-- 品牌统计 -->
            <div v-show="activeTab === 'brandStatistics'" class="tab-content">
                <BrandStatistics ref="partList" :start-time="startTime" :end-time="endTime"></BrandStatistics>
            </div>
            
            <!-- 单品统计 -->
            <div v-show="activeTab === 'productStatistics'" class="tab-content">
                <ProductStatistics :start-time="startTime" :end-time="endTime"></ProductStatistics>
            </div>
            
            <!-- 年度单项 -->
            <div v-if="showType != 'data'" class="tab-content">
                <AnnualItem :start-time="startTime" :end-time="endTime"></AnnualItem>
            </div>
        </div>
        <iframe  v-if="showType === 'data'" id="myFrame"  :src="iframeUrl" frameborder="0" width="100%" height="auto"></iframe>
    </div>
</div>
</template>

<script>
import BrandStatistics from './BrandStatistics.vue'
import ProductStatistics from './ProductStatistics.vue'
import AnnualItem from './AnnualItem.vue'

export default {
    components: {
        BrandStatistics,
        ProductStatistics,
        AnnualItem
    },
    data(){
        return{
            activeTab: 'brandStatistics', // 默认显示品牌统计
            showPartsList: false, // 控制是否显示返回按钮
            showGoodsDetail: false,
            startDate: '', // 开始日期
            endDate: '', // 结束日期
            startTime: Math.floor((Date.now() - 365 * 24 * 60 * 60 * 1000) / 1000), // 默认开始时间(365天前)
            endTime: Math.floor(new Date().getTime()/1000), // 默认结束时间,
            iframeUrl: 'https://huanuowei.cn/data/#/inveStatis',
            showType:""
        }
    },
    methods:{
        // 切换tab
        switchTab(tab,type) {
            this.activeTab = tab;
            if (type === 'data') {
                this.iframeUrl = 'https://huanuowei.cn/data/#/'+tab;
                // this.iframeUrl = 'http://localhost:8080/#/'+tab;
                
                this.$nextTick(() => {
                    this.adjustIframeHeight();
                });
            }
        },
        // 调整iframe高度
        adjustIframeHeight() {
            const iframe = document.getElementById('myFrame');
            if (!iframe) return;
            
            // 先设置一个基础高度
            iframe.style.height = '950px';
            
            // 使用定时器尝试获取真实高度
            setTimeout(() => {
                try {
                    // 尝试访问iframe内容（仅适用于同源）
                    const doc = iframe.contentDocument || iframe.contentWindow.document;
                    if (doc && doc.body) {
                        const height = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight, 600);
                        iframe.style.height = height + 'px';
                    }
                } catch (e) {
                    // 跨域情况下，使用轮询方式获取高度
                    this.pollIframeHeight(iframe);
                }
            }, 500);
        },
        // 轮询获取iframe高度（用于跨域情况）
        pollIframeHeight(iframe) {
            let attempts = 0;
            const maxAttempts = 10;
            const poll = () => {
                if (attempts >= maxAttempts) {
                    // 如果多次尝试后仍无法获取高度，使用默认高度
                    if (iframe.style.height.replace('px', '') < 600) {
                        iframe.style.height = '800px';
                    }
                    return;
                }
                attempts++;
                
                try {
                    const doc = iframe.contentDocument || iframe.contentWindow.document;
                    if (doc && doc.body) {
                        const height = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight, 600);
                        iframe.style.height = height + 'px';
                        return;
                    }
                } catch (e) {
                    // 继续轮询
                }
                
                setTimeout(poll, 1000);
            };
            
            setTimeout(poll, 1000);
        },
        // 处理时间变化
        handleDateChange() {
            // 当两个日期都有值且结束时间大于开始时间时才更新查询参数
            if (this.startDate && this.endDate) {
                const startTimestamp = Math.floor(this.startDate / 1000);
                const endTimestamp = Math.floor(this.endDate / 1000);
                
                if (endTimestamp > startTimestamp) {
                    this.startTime = startTimestamp;
                    this.endTime = endTimestamp;
                    // 不需要手动调用子组件方法，因为props变化会自动触发子组件的watcher
                    // 子组件会自动重新获取数据
                } else {
                    this.$warMsg('结束日期不能小于开始日期');
                }
            }
            // 如果任一个日期为空，保持默认时间范围不变
        },

        // 处理上传按钮点击
        handleUpload() {
            // 触发文件选择
            this.$refs.excelFile.click();
        },
        // 处理文件上传
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;
            
            // 检查文件类型
            const fileType = file.name.split('.').pop().toLowerCase();
            if (!['xlsx', 'xls'].includes(fileType)) {
                this.$warMsg('请上传Excel文件 (.xlsx 或 .xls)');
                return;
            }
            
            // 读取Excel文件
            this.readExcelFile(file);
        },
        // 读取Excel文件
        readExcelFile(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const XLSX = require('xlsx');
                    const workbook = XLSX.read(data, { type: 'array' });
                    
                    // 获取第一个工作表
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    
                    // 将工作表转换为JSON
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);
                    
                    // 提取生产码/生产编码列
                    const sccodes = jsonData.map(item => {
                        // 查找可能的生产码字段
                        return item['生产编码'] || item['生产码'] || item['sccode'] || item['SCCODE'] || '';
                    }).filter(code => code !== ''); // 过滤掉空值
                    
                    // 如果没有找到生产码，提示用户
                    if (sccodes.length === 0) {
                        this.$warMsg('未在Excel文件中找到生产码/生产编码列');
                        return;
                    }
                    
                    // 将生产码拼接成字符串
                    const sccodeString = sccodes.join(',');
                    
                    // 调用updateReport接口
                    this.$api.updateReport({
                        sccode: sccodeString
                    }).then(res => {
                        this.$suMsg('表格上传成功');
                        // 重置文件输入框
                        this.$refs.excelFile.value = '';
                        
                      
                    }).catch(err => {
                        this.$warMsg('表格上传失败: ' + err.message);
                        // 重置文件输入框
                        this.$refs.excelFile.value = '';
                    });
                } catch (error) {
                    this.$warMsg('文件解析失败: ' + error.message);
                    // 重置文件输入框
                    this.$refs.excelFile.value = '';
                }
            };
            reader.readAsArrayBuffer(file);
        }
    },
    created(){
       if(this.$store.state.store_id=='1780'){  
           this.showType = "data"
           console.log("this.$route.params.type",this.$route.params.type);
           
           if(this.$route.params.type!=1){
            this.switchTab(this.$route.params.type, 'data')
           }else{
            // 跳转对应页面
            // 检查是否有 inveStatis 权限，有则跳转到 inveStatis
            if(this.$store.state.storePath.includes('inveStatis')){
                this.switchTab('inveStatis', 'data');
            } else if(this.$store.state.storePath.includes('newSaleAnalysis')){
                // 如果没有 inveStatis 权限但有 newSaleAnalysis 权限，则跳转到 newSaleAnalysis
                this.switchTab('newSaleAnalysis', 'data');
            } else {
                this.$warMsg("暂无权限");
                setTimeout(() => {
                    this.$router.push({ path: '/' });
                }, 1500);
            }
           }
           
       }
       this.$api.getAnalysisLogNew({
            page: "reportCenter",
            module: '1',
            click_count: 1
        })
    },
    mounted() {
        this.$nextTick(() => {
            this.adjustIframeHeight();
        });
    },
    props:{
        
    }
}
</script>

<style lang="scss">
.hnw-zone{
    background: #F9F9F9;
    .tab-container {
        padding-top: 8px;
        .tab-header {
            display: flex;
            background: #fff;
            border-bottom: 1px solid #e4e4e4;
            padding: 6px 30px;
            .tab-item {
                padding: 12px 0;
                margin-right: 30px;
                cursor: pointer;
                font-size: 16px;
                color: #666;
                border-bottom: 2px solid transparent;
                &.active {
                    color: #3E84D6;
                    border-bottom: 2px solid #3E84D6;
                    font-weight: bold;
                }
            }
            .tab-actions {
                display: flex;
                align-items: center;
                margin-left: auto;
                .date-picker {
                    margin-right: 10px;
                    width: 150px;
                }
                .date-separator {
                    margin-right: 10px;
                    color: #999;
                }
                .upload-btn {
                    // height: 32px;
                }
            }
            .back-button {
                display: flex;
                align-items: center;
                padding: 12px 0;
                margin-left: 0;
                cursor: pointer;
                color: #409EFF;
                font-weight: bold;
                font-size: 16px;
            }
        }
        
        .tab-content {
            // padding: 20px;
            min-height: 400px;
        }
        
        #myFrame {
            // min-height: 1000px;
            transition: height 0.3s ease;
        }
    }
}
</style>